import { render, staticRenderFns } from "./pages2C.vue?vue&type=template&id=65f188aa&scoped=true&"
import script from "./pages2C.vue?vue&type=script&lang=js&"
export * from "./pages2C.vue?vue&type=script&lang=js&"
import style0 from "./pages2C.vue?vue&type=style&index=0&id=65f188aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f188aa",
  null
  
)

export default component.exports